<!-- 充能条h5页面 -->
<template>
  <div class="charge-strip-page" :class="bgClassList" v-if="rechargeBarInfo">

    <div class="awards-btn" @click="(awardRecordShow=true)">Records</div>

    <ul class="tabs">
      <li class="tab" :class="{active: tab===0}" @click="switchTab(0)">{{$t('chargeStrip.tabTask')}}</li>
      <li class="tab" :class="{active: tab===1}" @click="switchTab(1)">{{$t('chargeStrip.tabProgress')}}</li>
      <li class="tab" :class="{active: tab===2}" @click="switchTab(2)">{{$t('chargeStrip.tabRule')}}</li>
    </ul>

    <ul class="panels">

      <li class="panel room" v-show="tab===0">
        <div class="title">
          <i class="title-left-icon"></i>
          <span class="title-txt">{{$t('chargeStrip.tabTask')}}</span>
          <i class="title-right-icon"></i>
        </div>
        <div class="charge-strip-container">
          <div class="charge-strip-box">
            <div class="charge-strip-lv">
              <div class="charge-strip-lv-item"
                v-for="(item,index) in rechargeBarInfo.room_point_levels" 
                :key="index"
              > 
                <span v-if="(item.level_point<=rechargeBarInfo.room_point)" class="done"></span>
                <span v-else> {{item.level_content}}</span>
              </div>
            </div>
            <div class="charge-strip-bar">
              <div class="charge-strip-bar-reached" :style="{width: roomProgressReached + '%'}"></div>
              <div class="lv-dot-bar">
                <div 
                  v-for="(item,index) in rechargeBarInfo.room_point_levels" 
                  :key="index"
                  class="lv-dot"
                  :class="{done:item.level_point<=rechargeBarInfo.room_point}"
                >
                </div>
              </div>
            </div>
            <div class="charge-strip-point">
              <span class="charge-strip-point-item" 
                v-for="(item,index) in rechargeBarInfo.room_point_levels" 
                :key="index"
              >
                {{item.level_point}}
              </span>
            </div>
            <div v-if="roomProgressReached<100" class="current-point">
              Now an <span class="current-point-val"> {{rechargeBarInfo.room_point}}</span>
            </div>
            <div v-else class="current-point">
              <span class="current-point-val">Complete!</span>
            </div>
          </div>
          <div class="charge-strip-txt">
            {{$t('chargeStrip.consumeStar')}}
          </div>

          <div class="border-top"></div>
          <div class="bell"></div>
          <div class="border-bottom"></div>
          <div class="little-snowman"></div>
        </div>
        <div class="task-container">
          <div class="task-item follow">
            <div class="task-item-left">{{$t('chargeStrip.followRoomAward')}}</div>
            <div class="task-item-right">
              <div v-if="rechargeBarInfo?.is_follower" class="collected">Collected</div>
              <div v-else class="follow-complete-btn" @click="completeFollow">Follow</div> 
              <div class="energy">+ 3 Energy</div>
            </div>
          </div>
          <div class="task-item comment">
            <div class="task-item-left">{{$t('chargeStrip.sendDanmaku')}}</div>
            <div class="task-item-right">
              <div class="collected">Collected</div>
              <div v-if="rechargeBarInfo?.has_send_dm" class="energy">+ 1 Energy</div>
              <div v-else class="energy">+ 0 Energy</div>
            </div>
          </div>
          <div class="task-item top-up">
            <div class="task-item-left">{{$t('chargeStrip.consumeStarInRoom')}}</div>
            <div class="task-item-right">
              <div class="collected">Collected</div>
              <div class="energy">+ {{(rechargeBarInfo?.user_room_treasure||0)}} Energy</div>
            </div>
          </div>
          <div class="task-item watch">
            <div class="task-item-left">{{$t('chargeStrip.watchLiveAward')}}</div>
            <div class="task-item-right">
              <div  class="collected">Watched</div>
              <div  class="collected">{{(~~(rechargeBarInfo?.view_time/60))}}min</div>
              <div class="energy">+ {{(rechargeBarInfo?.view_time_point||0)}} Energy</div>
            </div>
          </div>
        </div>
      </li>
     
      <li class="panel station" v-show="tab===1">
        <div class="title">
          <i class="title-left-icon"></i>
          <span class="title-txt">{{$t('chargeStrip.tabProgress')}}</span>
          <i class="title-right-icon"></i>
        </div>

        <div class="charge-strip-container" v-if="rechargeBarInfo?.station_point_levels">
          <div class="charge-strip-box">
            <div class="charge-strip-lv">
              <div class="charge-strip-lv-item"
                v-for="item in rechargeBarInfo.station_point_levels" 
                :key="item.level_point"
              > 
                <span v-if="(item.level_point<=rechargeBarInfo.station_point)" class="done"></span>
                <span v-else> {{item.level_content}}</span>
              </div>
            </div>
            
            <div class="charge-strip-bar">
              <div class="charge-strip-bar-reached" :style="{width: stationProgressReached}"></div>
              <div class="lv-dot-bar">
                <div 
                  v-for="item in rechargeBarInfo.station_point_levels" 
                  :key="item.level_point"
                  class="lv-dot"
                  :class="{done:item.level_point<=rechargeBarInfo.station_point}"
                >
                </div>
              </div>
            </div>
            
            <div class="charge-strip-point">
              <span class="charge-strip-point-item" 
                v-for="item in rechargeBarInfo.station_point_levels" 
                :key="item.level_point"
              >
                {{item.level_point}}
              </span>
            </div>

            <div class="charge-value-box room">
              <div class="charge-value-box-left">
                {{$t('chargeStrip.uAddRoomEnergy')}}
              </div>
              <div class="charge-value-box-right">{{(rechargeBarInfo?.user_room_point || 0)}}</div>
            </div>
          
            <div class="charge-value-box station">
              <div class="charge-value-box-left">
                {{$t('chargeStrip.uAddStationEnerygy')}}
              </div>
              <div class="charge-value-box-right">{{(rechargeBarInfo?.user_station_point || 0)}}</div>
           </div>
          </div>

          <div class="border-top"></div>
          <div class="bell"></div>
          <div class="border-bottom"></div>
          <div class="little-snowman"></div>
        </div>

        <div class="task-intro-container">
          <div class="task-item follow">
            <div class="task-item-left"></div>
            <div class="task-item-right">
              {{$t('chargeStrip.followRoomAward')}}
            </div>
          </div>
          <div class="task-item comment">
            <div class="task-item-left"></div>
            <div class="task-item-right">
              {{$t('chargeStrip.sendDanmakuAward')}}
            </div>
          </div>
          <div class="task-item top-up">
            <div class="task-item-left"></div>
            <div class="task-item-right">
             {{$t('chargeStrip.consumeReward')}}
            </div>
          </div>
          <div class="task-item watch">
            <div class="task-item-left"></div>
            <div class="task-item-right">
              {{$t('chargeStrip.watchLive')}}
            </div>
          </div>
        </div>
      </li>
      
      <li class="panel rule" v-show="tab===2">
        <div class="title">
          <i class="title-left-icon"></i>
          <span class="title-txt">{{$t('chargeStrip.tabRule')}}</span>
          <i class="title-right-icon"></i>
        </div>
        <div class="rule-box">
          <div class="play-rule">
            <p class="play-rule-title">{{$t('chargeStrip.tabRule')}}</p>
            <p class="play-rule-desc">
              {{$t('chargeStrip.ruleDesc')}}
            </p>
          </div>
          <div class="award-rule">
            <p class="award-rule-title">{{$t('chargeStrip.prizesBoth')}}</p>
            <div class="award-total-station">
              <p class="award-total-station-title">{{$t('chargeStrip.prizeStation')}}</p>
              <div class="award-total-station-content">
                <p class="award-lv">LV1</p>
                <p class="award">Airpords pro*1</p>
                <p class="award-lv">LV2</p>
                <p class="award">iPad mini*1</p>
                <p class="award-lv">LV3</p>
                <p class="award">iPhone 14promax 128GB*1</p>
              </div>
            </div>
            <div class="award-room">
              <p class="award-room-title">{{$t('chargeStrip.prizeRoom')}}</p>
              <div class="award-room-content">
                <p class="award-lv">LV1</p>
                <p class="award">1 Star*10</p>
                <p class="award-lv">LV2</p>
                <p class="award">2 Star*30</p>
                <p class="award-lv">LV3</p>
                <p class="award">2 Star*100; 5 Star*10; {{$t('chargeStrip.avatarFrames')}}*100; {{$t('chargeStrip.premium')}}*10</p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <AwardRecord v-model:show="awardRecordShow"></AwardRecord>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted, onServerPrefetch } from 'vue';
import { useStore } from 'vuex';
import AwardRecord from './components/award-record.vue';
import roomService from '@/service/room';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import toast from '@/components/toast';
// import { initEnv, biliBridge, isSupport, inBiliApp } from '@bilibili/js-bridge';
// import VConsole from 'vconsole';
// new VConsole();

const {t: $t} = useI18n();
const route = useRoute();
const roomId = route.query.roomId;
const rechargeBarInfo  = ref<any>(null);
const awardRecordShow = ref(false);

const roomProgressReached = computed(() => {
  if(!rechargeBarInfo.value){
    return 0;
  }
  const room_point = rechargeBarInfo.value?.room_point || 0;
  const levelsLen = rechargeBarInfo.value?.room_point_levels?.length;
  const max_room_point = levelsLen ? rechargeBarInfo.value?.room_point_levels[levelsLen-1].level_point : 0;
  const seg = 1 / (levelsLen-1);
  
  let start = 0;
  let end = levelsLen-1;

  const endIndex = rechargeBarInfo.value?.room_point_levels.findIndex((item) => {
    return item.level_point >= room_point;
  });

  // 能量值0
  if(endIndex===0){
    return 0;
  }

  // 能量值超过最大值
  if(endIndex===-1){
    return 100;
  }

  start = endIndex - 1;
  end = endIndex;

  const startPoint =  rechargeBarInfo.value?.room_point_levels[start].level_point;
  const endPoint = rechargeBarInfo.value?.room_point_levels[end].level_point;
  const width = start * seg +  ((room_point - startPoint) / (endPoint-startPoint) * seg);

  return Math.min(width, 1) * 100;
});

const stationProgressReached = computed(() => {
  if(!rechargeBarInfo.value){
    return 0;
  }
  const station_point = rechargeBarInfo.value?.station_point || 0;
  const levelsLen = rechargeBarInfo.value?.station_point_levels?.length;
  const max_station_point = levelsLen ? rechargeBarInfo.value?.station_point_levels[levelsLen-1].level_point : 0;
  const seg = 1 / (levelsLen-1);
  
  let start = 0;
  let end = levelsLen-1;

  const endIndex = rechargeBarInfo.value?.station_point_levels.findIndex((item) => {
    return item.level_point >= station_point;
  });

  // 能量值0
  if(endIndex===0){
    return 0;
  }

  // 能量值超过最大值
  if(endIndex===-1){
    return 100 + '%';
  }

  start = endIndex - 1;
  end = endIndex;
    
  const startPoint =  rechargeBarInfo.value?.station_point_levels[start].level_point;
  const endPoint = rechargeBarInfo.value?.station_point_levels[end].level_point;

  const width = start * seg +  ((station_point - startPoint) / (endPoint-startPoint) * seg);

  return Math.min(width, 1) * 100 + '%';
});

// onServerPrefetch(async () => {
//   try{
//     const {data} = await roomService.getRechargeBarInfo(roomId);
//     rechargeBarInfo.value = data;
//   }catch(e){
//     console.log('**error(roomService.getRechargeBarInfo):',e);
//   }
// });

onMounted(async () => {
  if (!rechargeBarInfo.value) {
    try{
      const {data} = await roomService.getRechargeBarInfo(roomId);
      rechargeBarInfo.value = data;
    }catch(e){
      console.log('**error(roomService.getRechargeBarInfo):',e);
    }
  }
});

const store = useStore();
const bgClassList = computed(() => {
  const lang = store.state.global.sLocale;
  return [lang];
});

const tab = ref(0);
const switchTab =  (n:number) => {
  tab.value = n;
};
const completeFollow = async () => {
  try{
    const {data} = await roomService.completeFollow(roomId);
    rechargeBarInfo.value.is_follower = true;
  }catch(e){
    e?.message && toast({message:e.message, appendTo: '.task-container'});
  }
};
</script>


<style lang="less">
// 稿子 375px, 1vw = 375px
// html.font-size = 26.6666vw,  html.font-size = 375px * 0.26666 = 100px
// 1rem = 100px
html {
  font-size: 26.6666vw !important;

  body {
    font-size: 0.14rem;
  }
}
</style>

<style lang="less" scoped>

.charge-strip-page {
  max-width: 750px;
  padding-bottom: 0.4rem;
  margin: 0 auto;
  background: url('@/assets/charge-strip/bg-en.png') #530e15 no-repeat;
  background-size: 100%;
  position: relative;
  padding-top: 2.1rem;

  &.en {
    background-image: url('@/assets/charge-strip/bg-en.png');
  }

  &.id {
    background-image: url('@/assets/charge-strip/bg-id.png');
  }

  &.ms {
    background-image: url('@/assets/charge-strip/bg-ms.png');
  }

  &.vi {
    background-image: url('@/assets/charge-strip/bg-vi.png');
  }

  &.th {
    background-image: url('@/assets/charge-strip/bg-th.png');
  }

  .awards-btn {
    background: rgba(9, 48, 43, 0.74);
    border: 1px solid rgba(253, 229, 135, 0.4);
    border-right: none;
    border-radius: 0.15rem 0 0 0.15rem;
    line-height: 0.3rem;
    padding: 0 0.08rem 0 0.07rem;
    position: absolute;
    right: 0;
    top: 1.01rem;
    opacity: 0.7;
    font-size: 0.12rem;
    color: #fde587;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    cursor: pointer;
  }

  .tabs {
    display: flex;
    height: 0.3rem;
    width: 3.51rem;
    margin-left: 0.12rem;
    background: #7d1921;
    border-radius: 0.14rem;
    cursor: pointer;

    .tab {
      flex-grow: 1;
      width: 33.33%;
      padding: 0 0.06rem;
      font-size: 0.14rem;
      text-align: center;
      color: #fff;
      line-height: 0.3rem;
      letter-spacing: 0;
      font-weight: 700;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      &.active {
        height: 0.36rem;
        line-height: 0.42rem;
        position: relative;
        top: -0.06rem;
        color: #434502;
        background: url('@/assets/charge-strip/tab-btn.png') no-repeat 0 0;
        background-size: auto 0.36rem;
      }
    }
  }

  .panels {
    .panel {
      .title {
        margin-top: 0.08rem;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 0.3rem;
        font-size: 0.14rem;
        color: #fff;
        letter-spacing: 0;
        text-align: center;
        font-weight: 700;

        .title-txt {
          padding-top: 0.1rem;
          line-height: 0.2rem;
        }

        .title-left-icon {
          display: block;
          left: 0;
          top: 0;
          width: 0.53rem;
          height: 0.3rem;
          background: url('@/assets/charge-strip/deco-left.png') no-repeat left top;
          background-size: auto 100%;
        }

        .title-right-icon {
          display: block;
          right: 0;
          top: 0;
          width: 0.53rem;
          height: 0.3rem;
          background: url('@/assets/charge-strip/deco-right.png') no-repeat right top;
          background-size: auto 100%;
        }
      }

      .charge-strip-container {
        position: relative;
        width: 3.44rem;
        margin: 0.16rem auto 0;
        border-radius: 0.16rem;
        border: 0.04rem solid  #fff;
        background-color: #ffd783;
        padding: 0.08rem 0.08rem;

        .charge-strip-box {
          width: 3.19rem;
          background: #fff;
          border-radius: 0.08rem;
          padding-bottom: 0.12rem;

          .charge-strip-lv {
            padding: 0.16rem 0.08rem 0;
            // padding: 0.16rem 0.1rem 0 0.04rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 8px;
            color: #fe7057;
            letter-spacing: 0;
            text-align: center;
            line-height: 0.1rem;
            font-weight: 700;

            .charge-strip-lv-item {
              width: 0.3rem;
              display: flex;
              align-items: center;
              justify-content: center;

              .done {
                width: 100%;
                height: 0.1rem;
                background: url("@/assets/charge-strip/done.png") no-repeat 40% center;
                background-size: auto 100%;
              }

              &:first-of-type {
                .done {
                  background: none;
                }
              }
            }
          }

          .charge-strip-bar {
            position: relative;
            background: #dcdcdc;
            border-radius: 0.03rem;
            width: 2.88rem;
            height: 0.06rem;
            margin: 0.08rem 0.17rem 0 0.14rem;

            .charge-strip-bar-reached {
              background: #ff504f;
              border-radius: 0.03rem;
              height: 0.06rem;
              width: 0;
            }

            .lv-dot-bar {
              width: 100%;
              height: 100%;
              left: 0;
              top: 0;
              position: absolute;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .lv-dot {
                width: 0.12rem;
                height: 0.12rem;
                border-radius: 50%;
                background: #dcdcdc;
                border: 0.02rem solid rgba(255, 255, 255, 1);

                &.done {
                  background: #ff504f;
                }
              }
            }
          }

          .charge-strip-point {
            display: flex;
            align-items: center;
            justify-content: space-between;
            line-height: 0.17rem;
            padding: 0.05rem 0.1rem 0 0.04rem;
            font-size: 0.1rem;
            color: #666;
            letter-spacing: 0;
            text-align: center;
            font-weight: 700;

            .charge-strip-point-item {
              width: 0.3rem;
            }
          }

          .current-point {
            padding-left: 0.16rem;
            font-size: 0.12rem;
            color: #1a1a1a;
            letter-spacing: 0;
            line-height: 0.18rem;
            font-weight: 700;
            margin-top: 0.1rem;

            .current-point-val {
              font-size: 0.12rem;
              color: #ff504f;
              letter-spacing: 0;
              line-height: 0.18rem;
              font-weight: 700;
            }
          }

          .charge-value-box {
            width: 3.07rem;
            padding: 0.06rem;
            background: rgba(255, 220, 136, 0.3);
            border-radius: 0.06rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 auto;

            &:not(:first-of-type) {
              margin-top: 0.06rem;
            }

            .charge-value-box-left {
              width: 1.96rem;
              text-align: left;
              font-size: 0.12rem;
              color: #1a1a1a;
              letter-spacing: 0;
              line-height: 0.18rem;
              font-weight: 700;
            }

            .charge-value-box-right {
              min-width: 0.8rem;
              text-align: right;
              font-size: 0.2rem;
              color: #931c1b;
              letter-spacing: 0;
              font-weight: 700;
            }
          }
        }

        .charge-strip-txt {
          width: 3.16rem;
          margin: 0.06rem auto 0;
          font-size: 0.12rem;
          color: #1a1a1a;
          letter-spacing: 0;
          font-weight: 400;
        }

        .border-top {
          width: 3.3rem;
          height: 0.04rem;
          background: url("@/assets/charge-strip/border.png") no-repeat center center;
          background-size: 100%;
          position: absolute;
          left: -0.02rem;
          top: -0.04rem;
        }

        .border-bottom {
          width: 3.3rem;
          height: 0.04rem;
          background: url("@/assets/charge-strip/border.png") no-repeat center center;
          background-size: 100%;
          position: absolute;
          left: 0.02rem;
          bottom: -0.04rem;
        }

        .bell {
          position: absolute;
          width: 0.42rem;
          height: 0.36rem;
          background: url("@/assets/charge-strip/bell.png") no-repeat center center;
          background-size: 100%;
          left: -0.12rem;
          top: -0.12rem;
        }

        .little-snowman {
          width: 3.54rem;
          height: 0.68rem;
          background: url("@/assets/charge-strip/snowman.png") no-repeat center center;
          background-size: 100%;
          position: absolute;
          bottom: -0.21rem;
          left: -0.08rem;
        }
      }

      .task-container {
        position: relative;
        width: 3.31rem;
        height: 4.17rem;
        margin: 0.28rem auto 0;
        padding: 0.04rem;
        border-radius: 0.34rem 0.06rem 0.35rem 0.06rem;
        background: url("@/assets/charge-strip/border-g.png") no-repeat center center;
        background-size: 100%;

        &::before {
          content: ' ';
          width: 2.95rem;
          height: 0.16rem;
          position: absolute;
          right: 0;
          top: -0.05rem;
          background: url("@/assets/charge-strip/snow.png") no-repeat center center;
          background-size: 100%;
        }

        .task-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 0.1rem;
          padding-right: 0.09rem;

          &:not(:last-of-type) {
            border-bottom: 1px solid rgba(242, 221, 189, 1);
          }

          .task-item-left {
            width: 1.88rem;
            font-size: 0.12rem;
            color: #fff;
            letter-spacing: 0;
            font-weight: 400;
          }

          .task-item-right {
            width: 0.97rem;
            height: 0.71rem;
            background: rgba(0, 0, 0, 0.15);
            border-radius: 0.06rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            .follow-complete-btn {
              width: 0.72rem;
              height: 0.32rem;
              background-image: linear-gradient(180deg, #ffdb9b 0%, #ffaf41 87%);
              border: 0.02rem solid rgba(255, 220, 136, 1);
              border-radius: 0.17rem;
              font-size: 0.12rem;
              color: #1f403e;
              letter-spacing: 0;
              line-height: 0.32rem;
              font-weight: 700;
              text-align: center;
              cursor: pointer;
            }

            .collected {
              font-size: 0.14rem;
              color: #fef098;
              letter-spacing: 0;
              text-align: center;
              line-height: 0.18rem;
              font-weight: 700;
            }

            .energy {
              text-align: center;
              font-size: 0.1rem;
              color: #fdf19d;
              letter-spacing: 0;
              font-weight: 400;
              margin-top: 0.04rem;
              line-height: 0.14rem;
            }
          }

          &.follow {
            height: 0.94rem;
          }

          &.comment {
            height: 0.94rem;
          }

          &.top-up {
            height: 1.08rem;
          }

          &.watch {
            height: 1.14rem;
          }
        }
      }

      .task-intro-container {
        position: relative;
        width: 3.31rem;
        height: 4.17rem;
        margin: 0.28rem auto 0;
        padding: 0.04rem;
        border-radius: 0.34rem 0.06rem 0.35rem 0.06rem;
        background: url("@/assets/charge-strip/border-g.png") no-repeat center center;
        background-size: 100%;

        &::before {
          content: ' ';
          width: 2.95rem;
          height: 0.16rem;
          position: absolute;
          right: 0;
          top: -0.05rem;
          background: url("@/assets/charge-strip/snow.png") no-repeat center center;
          background-size: 100%;
        }

        .task-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 0.12rem;
          padding-right: 0.2rem;

          &:not(:last-of-type) {
            border-bottom: 1px solid rgba(242, 221, 189, 1);
          }

          .task-item-left {
            width: 0.7rem;
            height: 0.7rem;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 0.06rem;
            flex-shrink: 0;
          }

          .task-item-right {
            margin-left: 0.1rem;
            font-size: 0.12rem;
            color: #fff;
            letter-spacing: 0;
            font-weight: 400;
          }

          &.follow {
            height: 0.95rem;

            .task-item-left {
              background: url("@/assets/charge-strip/follow-icon.png") no-repeat center center;
              background-color: rgba(0, 0, 0, 0.1);
              background-size: 0.48rem;
            }
          }

          &.comment {
            height: 0.95rem;

            .task-item-left {
              background: url("@/assets/charge-strip/comment-icon.png") no-repeat center center;
              background-color: rgba(0, 0, 0, 0.1);
              background-size: 0.48rem;
            }
          }

          &.top-up {
            height: 1.06rem;

            .task-item-left {
              background: url("@/assets/charge-strip/consume-icon.png") no-repeat center center;
              background-color: rgba(0, 0, 0, 0.1);
              background-size: 0.48rem;
            }
          }

          &.watch {
            height: 1.14rem;

            .task-item-left {
              background: url("@/assets/charge-strip/watch-icon.png") no-repeat center center;
              background-color: rgba(0, 0, 0, 0.1);
              background-size: 0.48rem;
            }
          }
        }
      }

      .rule-box {
        width: 3.28rem;
        margin: 0.12rem auto 0;
        background-image: linear-gradient(180deg, #16906e 0%, #084f3d 100%);
        box-shadow: inset 0 0 0.1rem 0 rgba(29, 208, 132, 1);
        border-radius: 0.12rem;

        .play-rule {
          padding: 0.16rem 0.2rem 0.14rem 0.2rem;
          border-bottom: 2px solid rgba(189, 193, 164, 0.7);

          .play-rule-title {
            position: relative;
            font-size: 0.14rem;
            color: #fde587;
            letter-spacing: 0;
            font-weight: 600;

            &::before {
              display: block;
              content: ' ';
              width: 0.4rem;
              height: 0.4rem;
              transform: scale(0.1);
              background-color: #fde587;
              border-radius: 50%;
              position: absolute;
              left: -0.3rem;
              top: -0.1rem;
            }
          }

          .play-rule-desc {
            margin-top: 0.06rem;
            font-size: 0.12rem;
            color: #fff;
            letter-spacing: 0;
            font-weight: 400;
          }
        }

        .award-rule {
          padding-top: 0.13rem;
          padding-bottom: 0.25rem;

          .award-rule-title {
            position: relative;
            font-size: 0.14rem;
            color: #fde587;
            letter-spacing: 0;
            font-weight: 600;
            padding-left: 0.2rem;

            &::before {
              display: block;
              content: ' ';
              width: 0.4rem;
              height: 0.4rem;
              transform: scale(0.1);
              background-color: #fde587;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: -0.1rem;
            }
          }

          .award-total-station {
            width: 3.03rem;
            margin: 0.1rem auto 0;
            background: rgba(0, 0, 0, 0.12);
            border-radius: 0.06rem;
            padding: 0.11rem 0;

            .award-total-station-title {
              font-size: 0.12rem;
              color: #fff;
              letter-spacing: 0;
              font-weight: 400;
              padding-left: 0.08rem;
            }

            .award-total-station-content {
              display: grid;
              grid-template-columns: 0.34rem 1fr;
              grid-row-gap: 0.08rem;
              padding-left: 0.1rem;
              margin-top: 0.08rem;

              .award-lv {
                font-size: 0.12rem;
                color: #fde587;
                letter-spacing: 0;
                font-weight: 700;
              }

              .award {
                font-size: 0.12rem;
                color: #fde587;
                letter-spacing: 0;
                font-weight: 400;
              }
            }
          }

          .award-room {
            width: 3.03rem;
            margin: 0.1rem auto 0;
            background: rgba(0, 0, 0, 0.12);
            border-radius: 0.06rem;
            padding: 0.11rem 0;

            .award-room-title {
              font-size: 0.12rem;
              color: #fff;
              letter-spacing: 0;
              font-weight: 400;
              padding-left: 0.08rem;
            }

            .award-room-content {
              display: grid;
              grid-template-columns: 0.34rem 1fr;
              grid-row-gap: 0.08rem;
              padding-left: 0.1rem;
              margin-top: 0.08rem;

              .award-lv {
                font-size: 0.12rem;
                color: #fde587;
                letter-spacing: 0;
                font-weight: 700;
              }

              .award {
                font-size: 0.12rem;
                color: #fde587;
                letter-spacing: 0;
                font-weight: 400;
              }
            }
          }
        }
      }

      &.room {
        .charge-strip-container {
          padding-bottom: 0.14rem;
        }
      }

      &.station {
        .charge-strip-container {
          padding-bottom: 0.1rem;
        }
      }
    }
  }
}

</style>
